export default "__VITE_ASSET__Dzhg1VSa__"